import { dashboardReducer } from "../reducer/DashboardReducer";

export const reducer = dashboardReducer;
